"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutPOSTResponseMapper = void 0;
var CheckoutPOSTResponseMapper = /** @class */ (function () {
    function CheckoutPOSTResponseMapper(data) {
        this.localData = data;
    }
    CheckoutPOSTResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CheckoutPOSTResponseMapper;
}());
exports.CheckoutPOSTResponseMapper = CheckoutPOSTResponseMapper;
//# sourceMappingURL=CheckoutPOSTResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CheckoutPOSTResponseMapper.js
// module id = 2066
// module chunks = 8